import { useMemo } from 'react';
import { Screen, withScreen, createScreenRoute } from '@gogame/screens';
import { Grid, Switch, Paper, makeStyles } from '@gogame/components';
import { TemplatesProvider } from 'Templates';

import { tapjoyBidUpdateLink } from './navigation';
import ProcessingFile from './components/ProcessingFile';
import UploadFile from './components/UploadFile';
import DownloadTemplate from './components/DownloadTemplate';

import { useLoadStatus } from './data/useLoadStatus';
import { useLoadAutoUpdateViaApi } from './data/useLoadAutoUpdateViaApi';
import { useUpdateIsAllowExternalAPI, useStartJob } from './data/mutations';

import Alerts from './components/Alerts';

import { STATUS_NOT_STARTED, STATUS_RUNNING } from './constants';
const useStyles = makeStyles(() => ({
  switch: {
    margin: 0,
  },
}));

const id = 62;
const permission = 102;

const TapjoyBidUpdateScreen = withScreen({
  name: 'tapjoy-bid-update',
})(() => {
  const classes = useStyles();
  const { data: statusDetails } = useLoadStatus();
  const { data: isAutoUpdateViaAPI } = useLoadAutoUpdateViaApi();
  const [startJob] = useStartJob();

  const handleUpload = async (file) => {
    await startJob({ file });
  };
  const [updateIsAllowExternalAPI] = useUpdateIsAllowExternalAPI();

  const handleChangeAllowBidUpdatesViaAPI = async (_, value) => {
    await updateIsAllowExternalAPI({ value });
  };

  const isProcessing = useMemo(() => {
    if (!statusDetails) {
      return false;
    }
    return [STATUS_NOT_STARTED, STATUS_RUNNING].includes(
      statusDetails?.status?.id
    );
  }, [statusDetails]);

  return (
    <TemplatesProvider serverPageId={id}>
      <Screen.Toolbar />
      <Screen.Body>
        <Grid container direction={'column'} spacing={2}>
          <Grid item>
            <Paper variant={'outlined'} sx={{ p: 1 }}>
              <Grid container spacing={1} direction={'column'}>
                <Grid item>
                  {isProcessing ? (
                    <ProcessingFile data={statusDetails} />
                  ) : (
                    <UploadFile
                      onDropFile={handleUpload}
                      onChooseFile={handleUpload}
                    />
                  )}
                </Grid>
                {!isProcessing && statusDetails && (
                  <Alerts statusDetails={statusDetails} />
                )}
              </Grid>
            </Paper>
          </Grid>
          <Grid
            container
            item
            alignItems={'center'}
            justifyContent={'center'}
            spacing={2}
          >
            <Grid item>
              <Switch
                label={'Allow bid updates via API'}
                checked={isAutoUpdateViaAPI}
                onChange={handleChangeAllowBidUpdatesViaAPI}
                className={classes.switch}
              />
            </Grid>
            <Grid item sx={{ color: 'text.secondary' }}>
              •
            </Grid>
            <Grid item>
              <DownloadTemplate />
            </Grid>
          </Grid>
        </Grid>
      </Screen.Body>
    </TemplatesProvider>
  );
});

export default createScreenRoute({
  title: 'Tapjoy Bid Update',
  link: tapjoyBidUpdateLink,
  screen: <TapjoyBidUpdateScreen />,
  id: id,
  permission: permission,
  knowledgeBaseUrl:
    'https://go-game.zendesk.com/hc/en-us/articles/19640266865052-Tapjoy-Bid-Update',
});
